import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-70d86d55"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "boxall",
    style: { "height": "3rem" },
    id: "boxrule"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "alltitle" }, "分项指标", -1));
const _hoisted_3 = {
    class: "bannerPc banner-ccslide",
    style: { "height": "100%", "position": "relative", "overflow": "hidden" }
};
const _hoisted_4 = { style: { "position": "absolute", "transform": "translate(-50%, -50%)", "top": "50%", "left": "50%" } };
const _hoisted_5 = ["id"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "boxfoot" }, [
    /*#__PURE__*/ _createElementVNode("span", { id: "borrow_date" })
], -1));
import { onMounted, onUnmounted, ref, watch } from "vue";
import * as echarts from "echarts";
import useAxios from '../../assets/utils/http/useAxious';
import windowResize from "@/utils/resize";
import { registerChart, unregisterChart } from "@/utils/chartResize";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScreenRightCenter',
    setup(__props) {
        const { screenRef, calcRate, windowDraw, unWindowDraw } = windowResize();
        const loading = ref(true);
        onMounted(() => {
            // 监听浏览器窗口尺寸变化
            windowDraw();
            calcRate();
            setTimeout(() => {
                loading.value = false;
            }, 2000);
        });
        onUnmounted(() => {
            unWindowDraw();
        });
        const { get } = useAxios();
        const subtext = ref(false);
        const localChartData = ref({
            duplicate: [],
            AvgBook: [],
            Reader: [],
            literature: []
        });
        const chartsData = ref([
            { id: 'echartsv1', color: '#f7c32b', label: '平均复本数', unit: '本' },
            { id: 'echartsv2', color: '#3f92e6', label: '人均藏书', unit: '册' },
            { id: 'echartsv3', color: '#6b0ce1', label: '读者借阅占比', unit: '%' },
            { id: 'echartsv4', color: '#df155b', label: '文献利用率', unit: '%' }
        ]);
        const fetchData = async () => {
            try {
                const data = await get('/organizations/subindicators', {});
                if (data.ok === true) {
                    localChartData.value.duplicate = [data.msg.FuBenShu];
                    localChartData.value.AvgBook = [(data.msg.BooksPerReader).toFixed(2)];
                    localChartData.value.Reader = [(data.msg.PercentAgeorrowing * 100).toFixed(2)];
                    localChartData.value.literature = [(data.msg.LiteratureUtilization * 100).toFixed(2)];
                    updateChartsData();
                }
                else {
                    console.log("获取数据错误，请联系管理员");
                }
            }
            catch (error) {
                console.log(error);
            }
        };
        const updateChartsData = () => {
            chartsData.value[0].value = localChartData.value.duplicate[0];
            chartsData.value[1].value = localChartData.value.AvgBook[0];
            chartsData.value[2].value = localChartData.value.Reader[0];
            chartsData.value[3].value = localChartData.value.literature[0];
        };
        const createChartOptions = (titleText, color, value, unit) => {
            return {
                title: {
                    text: `${titleText} ${unit}`,
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontWeight: 'normal',
                        color: '#FFD700',
                        fontSize: '20'
                    }
                },
                color: ['#e9edfc'],
                series: [{
                        type: 'pie',
                        clockWise: true,
                        radius: ['80%', '95%'], // 调整环形的内外半径，增加环形之间的间隙
                        itemStyle: {
                            normal: {
                                label: { show: false },
                                labelLine: { show: false },
                                borderColor: 'transparent',
                                borderWidth: 0,
                            }
                        },
                        hoverAnimation: false,
                        data: [{
                                value: value,
                                name: '01',
                                itemStyle: {
                                    normal: {
                                        color: color,
                                        label: { show: false },
                                        labelLine: { show: false },
                                    }
                                },
                                label: { show: false },
                                labelLine: { show: false },
                            }, {
                                name: '01',
                                value: 10,
                            }]
                    }]
            };
        };
        const initCharts = () => {
            chartsData.value.forEach(chartData => {
                const chartDom = document.getElementById(chartData.id);
                if (chartDom) {
                    const chart = echarts.init(chartDom);
                    // function resizeChart() {
                    //   var width = window.innerWidth / 15;
                    //   var height =window.innerHeight / 4.5;
                    //   // 设置图表大小
                    //   chart.resize({
                    //     width: width,
                    //     height: height
                    //   });
                    // }
                    chart.setOption(createChartOptions(chartData.value, chartData.color, chartData.value, chartData.unit));
                    chart.resize();
                    // 走全局统一 resize 管理；subtext / windowWidth 的 watch 会反复触发 initCharts，
                    // 同一 chart 实例只占一个槽位，不再每次新增一个匿名 resize 监听
                    registerChart(chart);
                    // resizeChart()
                    // window.addEventListener('resize', () => resizeChart());
                }
            });
        };
        onMounted(() => {
            // if (localStorage.getItem('Authorization')) {
            //   fetchData().then(() => {
            //     initCharts();
            //   });
            //   subtext.value = true;
            // } else {
            //   subtext.value = false;
            // }
            if (localStorage.getItem('Authorization') === null || localStorage.getItem('Authorization') === 'Bearer undefined' || localStorage.getItem('Authorization') === undefined || localStorage.getItem('Authorization') === '') {
                subtext.value = false;
            }
            else {
                fetchData().then(() => {
                    initCharts();
                });
                subtext.value = true;
            }
        });
        onUnmounted(() => {
            chartsData.value.forEach(chartData => {
                const chartDom = document.getElementById(chartData.id);
                if (chartDom) {
                    const chart = echarts.getInstanceByDom(chartDom);
                    if (chart) {
                        unregisterChart(chart);
                        chart.dispose();
                    }
                }
            });
        });
        watch(() => window.innerWidth, () => {
            initCharts();
        });
        watch(() => subtext.value, () => {
            initCharts();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "chart-container",
                            ref_key: "screenRef",
                            ref: screenRef
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartsData.value, (chart, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: chart.id,
                                    class: "chart-wrapper"
                                }, [
                                    _withDirectives(_createElementVNode("div", {
                                        id: chart.id,
                                        class: "chart"
                                    }, null, 8, _hoisted_5), [
                                        [_vShow, subtext.value]
                                    ]),
                                    _withDirectives(_createElementVNode("span", {
                                        class: _normalizeClass(['subtext', `subtext${index + 1}`])
                                    }, _toDisplayString(chart.label) + " (" + _toDisplayString(chart.unit) + ")", 3), [
                                        [_vShow, subtext.value]
                                    ])
                                ]));
                            }), 128))
                        ], 512)
                    ])
                ]),
                _hoisted_6
            ]));
        };
    }
});
